/**
 * This file let you add new Trackings to projects.
 */

// import * as trackingName from '@/components/ui-logic/trackings/tracking-name'

const customTrackings = {}

export default customTrackings
